import type { UserAddressInput } from '../types/api';
import PhoneInput from './PhoneInput';

type AddressFormProps = {
  idPrefix?: string;
  value: UserAddressInput;
  onChange: (value: UserAddressInput) => void;
  showDefaultFlags?: boolean;
  disabled?: boolean;
};

export default function AddressForm({
  idPrefix = 'address',
  value,
  onChange,
  showDefaultFlags = false,
  disabled = false,
}: AddressFormProps) {
  const update = <K extends keyof UserAddressInput>(key: K, nextValue: UserAddressInput[K]) => {
    onChange({ ...value, [key]: nextValue });
  };

  return (
    <div className="address-form">
      <div className="form-group">
        <label htmlFor={`${idPrefix}-label`}>Adres etiketi</label>
        <input
          id={`${idPrefix}-label`}
          value={value.label}
          placeholder="Ev, İş, Depo..."
          disabled={disabled}
          required
          onChange={(event) => update('label', event.target.value)}
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor={`${idPrefix}-firstName`}>Ad</label>
          <input
            id={`${idPrefix}-firstName`}
            value={value.firstName}
            disabled={disabled}
            required
            onChange={(event) => update('firstName', event.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor={`${idPrefix}-lastName`}>Soyad</label>
          <input
            id={`${idPrefix}-lastName`}
            value={value.lastName}
            disabled={disabled}
            required
            onChange={(event) => update('lastName', event.target.value)}
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor={`${idPrefix}-phone`}>Telefon</label>
        <PhoneInput
          id={`${idPrefix}-phone`}
          value={value.phone}
          disabled={disabled}
          required
          onChange={(phone) => update('phone', phone)}
        />
      </div>

      <div className="form-group">
        <label htmlFor={`${idPrefix}-address`}>Adres</label>
        <textarea
          id={`${idPrefix}-address`}
          rows={3}
          value={value.address}
          disabled={disabled}
          required
          onChange={(event) => update('address', event.target.value)}
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor={`${idPrefix}-city`}>Şehir</label>
          <input
            id={`${idPrefix}-city`}
            value={value.city}
            disabled={disabled}
            required
            onChange={(event) => update('city', event.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor={`${idPrefix}-district`}>İlçe</label>
          <input
            id={`${idPrefix}-district`}
            value={value.district}
            disabled={disabled}
            required
            onChange={(event) => update('district', event.target.value)}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor={`${idPrefix}-zip`}>Posta Kodu</label>
          <input
            id={`${idPrefix}-zip`}
            value={value.zip}
            disabled={disabled}
            required
            onChange={(event) => update('zip', event.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor={`${idPrefix}-country`}>Ülke</label>
          <input
            id={`${idPrefix}-country`}
            value={value.country}
            disabled={disabled}
            required
            onChange={(event) => update('country', event.target.value.toUpperCase())}
          />
        </div>
      </div>

      {showDefaultFlags && (
        <div className="address-form-flags">
          <label className="address-checkbox">
            <input
              type="checkbox"
              checked={Boolean(value.isDefaultShipping)}
              disabled={disabled}
              onChange={(event) => update('isDefaultShipping', event.target.checked)}
            />
            Varsayılan teslimat adresi
          </label>
          <label className="address-checkbox">
            <input
              type="checkbox"
              checked={Boolean(value.isDefaultBilling)}
              disabled={disabled}
              onChange={(event) => update('isDefaultBilling', event.target.checked)}
            />
            Varsayılan fatura adresi
          </label>
        </div>
      )}
    </div>
  );
}
